export default {
  tasks: (state) => {
    return state.tasks;
  },
  statsLeads: (state) => {
    return state.stats_leads;
  },
  statsOpportunities: (state) => {
    return state.stats_opportunities;
  },
  statsSales: (state) => {
    return state.stats_sales;
  },
  invitations: (state) => {
    return state.invitations;
  },
  members: (state) => {
    return state.members;
  },
  currentTeam: (state) => {
    return state.current_team;
  },
  subscription(state) {
    return state.subscription;
  },
};
